module.exports = __webpack_public_path__ + "static/media/starPoster.608a2b85.jpg";